var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0C19.9375 0 20.2969 0.140625 20.5781 0.421875C20.8594 0.734375 21 1.09375 21 1.5V19.5C21 19.9062 20.8594 20.2656 20.5781 20.5781C20.2969 20.8594 19.9375 21 19.5 21H1.5C1.0625 21 0.703125 20.8594 0.421875 20.5781C0.140625 20.2656 0 19.9062 0 19.5V1.5C0 1.09375 0.140625 0.734375 0.421875 0.421875C0.703125 0.140625 1.0625 0 1.5 0H19.5ZM6.375 18V7.96875H3.23438V18H6.375ZM4.78125 6.60938C5.3125 6.60938 5.73438 6.4375 6.04688 6.09375C6.39062 5.75 6.57812 5.32812 6.60938 4.82812C6.57812 4.29688 6.39062 3.85938 6.04688 3.51562C5.73438 3.17188 5.3125 3 4.78125 3C4.28125 3 3.85938 3.17188 3.51562 3.51562C3.17188 3.85938 3 4.29688 3 4.82812C3 5.32812 3.17188 5.75 3.51562 6.09375C3.85938 6.4375 4.28125 6.60938 4.78125 6.60938ZM18 18V12.5156C18.0625 11.1406 17.8438 10 17.3438 9.09375C16.8438 8.21875 15.8281 7.76562 14.2969 7.73438C13.5156 7.73438 12.875 7.90625 12.375 8.25C11.875 8.5625 11.5312 8.92188 11.3438 9.32812H11.2969V7.96875H8.29688V18H11.4375V13.0312C11.4062 12.3438 11.5 11.75 11.7188 11.25C11.9688 10.75 12.4844 10.4844 13.2656 10.4531C14.0469 10.5156 14.5156 10.8125 14.6719 11.3438C14.8594 11.9062 14.9375 12.5 14.9062 13.125V18H18Z",
    fill: "#F1F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.48a33d5125ee4f59add33adb63b97333.svg";
export { ForwardRef as ReactComponent };